import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUploadCeDocument } from '../types';

const onUploadCeDocument: IThunkUploadCeDocument = thunk(async (_, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { fileName } = await api.file.uploadFile(formData).then(response => response.data);

  return { fileId: fileName, fileName: file.name };
});

export default onUploadCeDocument;
